import type { IconSvgObject } from './types';

const SquareRoundCornerIcon: IconSvgObject = [
  ["path", { d: "M21 15C21 17.3389 21 18.5083 20.4635 19.3621C20.1838 19.8073 19.8073 20.1838 19.3621 20.4635C18.5083 21 17.3389 21 15 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V9C3 6.66111 3 5.49167 3.53647 4.63789C3.81621 4.19267 4.19267 3.81621 4.63789 3.53647C5.49167 3 6.66111 3 9 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 11C20.7376 8.33208 20.1445 6.53625 18.8041 5.19588C17.4638 3.8555 15.6679 3.26242 13 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareRoundCornerIcon;
